<!--
用法：
v-model : 双向绑定 图片路径存储字段 ，比如物品的  picture属性
root-path : 文件在服务器存储的路径 ，比如物品照片存储路径  item
folder-name : 文件在服务器的文件夹名 ，比如  {物品编码}
owner :  图片所有者，比如物品的照片，可以设定 owner 为物品代码； 出库单的照片，可以设定 owner为 单据号。
说明： 上传的文件，自动在 文件夹下面按顺序重命名 比如  MPS013_1.JEPG MPS013_2.JEPG
 <file-upload v-model="inputForm.picture"
               root-path="item"
               :folder-name="inputForm.code"
               :owner="inputForm.code"
                :read-only="method=='view'"
                ></file-upload>
-->

<template>
  <div
    class="projectFileUpload"
    style="min-height: 650px;padding: 10px"
    :class="dropActive ? 'drag-active' : ''"
    @drop.prevent="drop"
    @dragenter.prevent="dragenter"
    @dragover.prevent="dragover"
    @dragleave.prevent="dragleave"
  >
    <div style="margin-bottom:10px; max-height: 300px;  z-index: 5;">
      <el-image
        v-if="fileList.length>0"
        @click="showPic()"
        style="object-fit: contain; height: 300px; width: 540px;"
        :src="getFullPathUrl(currentFile)"
        @error="hideErrorImage()"
        alt
      ></el-image>
      <!-- <span
        v-if="fileList.length>0&&!readOnly && currentFile.url!=undefined"
        :style="'border-color:'+defaultTheme+' !important; cursor: pointer; '"
        class="image-remove-icon"
        @click="onRemove(currentFile)"
      >
        <i
          class="el-icon-close"
          :style="'display:block !important;color:'+defaultTheme+' !important;top:0px;right:0px;'"
        ></i>
      </span> -->

      <!-- <i v-if="!readOnly && currentFile.url!=undefined" class="el-icon-close delIconClass" @click="onRemove(currentFile)"
      :style="imgEmpty?'color:red':''"></i> -->
    </div>
    <div >
      <el-upload
        ref="upload"
        list-type="picture-card"
        accept=".jpg, .jpeg, .png, .JPG, .JPEG, .PNG, .MP4, .mp4"
        action="#"
        :multiple="multiple"
        :file-list="fileList"
        :show-file-list="true"
        :on-remove="onRemove"
        :on-progress="onProgress"
        :before-remove="beforeRemove"
        :before-upload="beforeUpload"
        :http-request="uploadImage"
        :auto-upload="true"
      >
        <!--          <i class="el-icon-plus"></i>-->
        <slot>
          <i class="el-icon-plus"></i>
        </slot>
      </el-upload>
    </div>

    <div v-show="false" class="images">
      <img v-for="(src, index) in getAllImg()" :src="src" :key="index" />
    </div>
  </div>
</template>

<script>
import ImageCompressor from 'image-compressor.js'
import config from '../upload/config'
export default {
  props: {
    watermark: {
      type: String,
      default: ''
    },
    multiple: {
      // 是否支持多选
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 20
    },
    showPreview: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    uploadPath: {
      type: String,
      default: 'upload_files'
    },
    rootPath: {
      type: String,
      default: 'upload_files'
    },
    folderName: {
      type: String,
      default: ''
    },
    owner: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    allowDelFromServer: {
      type: Boolean,
      default: true
    },
    isShow: {
      type: Boolean,
      default: false
    },
    separator: {
      // 文件命名分隔符
      type: String,
      default: '_'
    },
    // 是否保存原始文件名
    keepOriginName: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    ifSetUploadName: {
      type: Boolean,
      default: false
    },
    updateParams: {
      type: Object,
      default: () => {
        return {
          fileName: '',
          tip: '',
          code: ''
        }
      }
    }
  },
  data () {
    return {
      splitChar: '|',
      currentImgUrl: '',
      currentFile: {},
      disabled: false,
      fileList: [],
      imgViewSize: '800px',
      imagesList: [],
      imgEmpty: false, // 图片不存在
      dropActive: false,
      defaultTheme: localStorage.defaultTheme,
      uploadNum: 1
    }
  },
  watch: {
    owner (val, oldVal) {
      this.imgEmpty = false
      // let that = this
      if (val !== oldVal && val !== '') {
        //  console.log(`watch:: owner变更 ${oldVal} -->  ${val}` )
        this.bindUI(val)
      } else if (val === '') {
        this.init()
      }
    },
    visible: {
      handler (n) {
        if (n) {
          document.addEventListener('paste', this.pasteEvent)
        } else {
          document.removeEventListener('paste', this.pasteEvent)
        }
      },
      immediate: true
    },
    ownerLength: {
      handler (newVal) {
        if (newVal === 0) {
          // this.dots = []
          // this.tableList = []
        }
      },
      immediate: false,
      deep: true
    }
  },
  computed: {
    actionUrl () {
      let url = `/sys/file/cec/smartUpload2?rootPath=${this.rootPath}&forderName=${this.folderName}`
      // watermark 不为空时，才传递 use isBlank method
      if (
        this.watermark !== null &&
        this.watermark !== '' &&
        this.watermark !== undefined
      ) {
        url += `&watermark=${this.watermark}`
      }
      return url
    },
    imgFileCount () {
      let count = 0
      for (let file of this.fileList) {
        if (this.canPreview(this.getFullPathUrl(file))) {
          count++
        }
      }
      return count
    },
    ownerLength () {
      return this.owner.length
    }
  },
  activated () {},
  mounted () {},
  methods: {
    // 粘贴上传
    pasteEvent (event) {
      if (this.readOnly) {
        return
      }
      if (event && event.clipboardData) {
        const file = event.clipboardData.items[0].getAsFile()
        if (file) {
          // if (this.fileList.length >= this.limit) {
          //   this.$message.error(`最多只能上传${this.limit}个附件`)
          //   return
          // }
          const imageFile = new File(
            [file],
            `JT_${new Date().getTime()}_${Math.floor(
              Math.random() * 10000
            )}.png`
          )
          this.uploadImage({ file: imageFile })
        }
      }
    },
    drop (e) {
      this.dropActive = false
      const files = e.dataTransfer.files
      // if (this.fileList.length >= this.limit) {
      //   this.$message.error(`最多只能上传${this.limit}个附件`)
      //   return
      // }
      // if (this.limit === 1) {
      //   const file = files[0]
      //   this.uploadImage({ file })
      //   return
      // }
      if (this.limit === 0) {
        files.forEach(file => {
          this.uploadImage({ file })
        })
        return
      }
      const residueNum = this.limit - this.fileList.length
      if (residueNum <= 0) {
        return
      }
      let max = residueNum > files.length ? files.length : residueNum
      for (let i = 0; i < max; i++) {
        const file = files[i]
        this.uploadImage({ file })
      }
    },
    dragenter (e) {
      this.dropActive = true
    },
    dragover (e) {
      this.dropActive = true
    },
    dragleave (e) {
      this.dropActive = false
    },
    showPic () {
      const vuer = this.$el.querySelector('.images').$viewer
      vuer.show()
    },
    hideErrorImage () {
      this.imgEmpty = true
    },
    canPreview (fileurl) {
      if (fileurl.toUpperCase().endsWith('.PNG')) return true
      if (fileurl.toUpperCase().endsWith('.JPG')) return true
      if (fileurl.toUpperCase().endsWith('.IMG')) return true
      if (fileurl.toUpperCase().endsWith('.JPEG')) return true
      if (fileurl.toUpperCase().endsWith('.GIF')) return true
      return false
    },
    getFileTypeIcon (fileurl) {
      if (fileurl.toUpperCase().endsWith('.PDF')) {
        return '/static/icon/filetype/pdf.png'
      }
      if (fileurl.toUpperCase().endsWith('.XLSX')) {
        return '/static/icon/filetype/xlsx.png'
      }
      if (fileurl.toUpperCase().endsWith('.DOCX')) {
        return '/static/icon/filetype/docx.png'
      }
      if (fileurl.toUpperCase().endsWith('.XLS')) {
        return '/static/icon/filetype/xlsx.png'
      }
      if (fileurl.toUpperCase().endsWith('.DOC')) {
        return '/static/icon/filetype/docx.png'
      }
      if (fileurl.toUpperCase().endsWith('.RAR')) {
        return '/static/icon/filetype/rar.png'
      }
      if (fileurl.toUpperCase().endsWith('.ZIP')) {
        return '/static/icon/filetype/zip.png'
      }
      if (fileurl.toUpperCase().endsWith('.TXT')) {
        return '/static/icon/filetype/txt.png'
      }
      if (fileurl.toUpperCase().endsWith('.MP4')) {
        return '/static/icon/filetype/video.png'
      }
      return '/static/icon/filetype/file.png'
    },
    getAllImg () {
      let imgs = []
      for (let file of this.fileList) {
        imgs.push(this.getFullPathUrl(file))
      }
      return imgs
    },
    getFullPathUrl (file) {
      // if(this.getRealUrl(file).indexOf('/')>-1) return  this.getRealUrl(file)
      // return `/userfiles/${this.rootPath}/${this.folderName.toUpperCase()}/${this.getRealUrl(file)}`
      // return `/userfiles/${this.rootPath}/${this.getRealUrl(file)}`
      return file.url
    },
    getMathRandom () {
      return '?' + new Date().getTime() + '' + Math.floor(Math.random() * 10)
    },
    getRealUrl (file) {
      // let result=file.response ? file.response.url :file.url
      let result = file.name
      if (result === undefined) result = ''
      return result
    },
    init () {
      this.fileList = []
      this.currentImgUrl = ''
      this.currentFile = {}
    },
    // 拼接url
    setUrlHearder (url) {
      return url.indexOf('http') >= 0 ? url : process.env.VUE_APP_SERVER_URL + url
    },
    bindUI (val) {
      let files = []
      this.fileList = []
      if (val !== null && val !== '' && val !== undefined) {
        // let fileArrays = val.split(this.splitChar)
        for (let i = 0; i < val.length; i++) {
          files.push({
            name: val[i].name,
            url: this.setUrlHearder(val[i].filePath),
            fileName: val[i].fileName,
            filePath: val[i].filePath,
            fileSize: val[i].fileSize,
            actorId: val[i].actorId,
            actorName: val[i].actorName,
            startTime: val[i].startTime,
            categoryName: val[i].categoryName,
            description: val[i].description,
            category: val[i].category,
            id: val[i].id,
            createDate: val[i].createDate,
            pixel: val[i].pixel
          })
        }
        if (files.length > 0) {
          this.currentFile = files[0]
        }
      } else {
        files = []
      }
      this.uploadNum = files.length + 1
      this.fileList = files
    },
    appendFileToValue (file) {
      // console.log('appendFileToValue:: ', file)
      let val = this.value
      let url = file.response ? file.response.url : file.url
      val = val + (val === '' ? '' : this.splitChar) + url
      this.updateVal(val)
    },
    saveFileListToValue () {
      let val = ''
      let that = this
      // console.log('saveFileListToValue', this.fileList)
      this.fileList.forEach(function (file, index, arr) {
        let url = file.response ? file.response.url : file.url
        val = val + (val === '' ? '' : that.splitChar) + url
      })
      // console.log('saveFileListToValue', val)
      this.updateVal(val)
    },
    beforeUpload (file) {
      // console.log('file::', file )
    },
    navToImg (file) {
      this.currentFile = file
    },
    updateVal: function (val) {
      // 2、手动触发父组件的input事件并将值传给父组件
      this.$emit('input', val)
    },
    onChange (file, fileList) {
      this.fileList = fileList
      if (file.status === 'success') {
        this.navToImg(file)
      }
    },
    onSuccess (response, file, fileList) {
      // this.imgEmpty = false
      // if(response.success) this.fileList=fileList
      //   this.appendFileToValue(file)
    },
    delFileByUrl (fileUrl) {
      if (this.allowDelFromServer) {
        this.$http({
          url: `/sys/file/cec/delFileByUrl`,
          method: 'post',
          data: { url: fileUrl }
        }).then(({ data }) => {
          this.imgEmpty = false
        })
      }
    },
    beforeRemove (file, fileList) {
      // 从服务器删除文件
      this.onRemove(file)
      return false
    },
    onRemove (file) {
      this.$confirm(`确定删除图片吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.imgEmpty = false
        // if (!this.beforeRemove(file)) return
        let delIndex = -1
        this.fileList.forEach(function (item, index, arr) {
          if (item.uid === file.uid) {
            delIndex = index
          }
        })
        if (delIndex > -1) {
          this.fileList.splice(delIndex, 1)
          if (this.fileList.length > 0) {
            if (delIndex < this.fileList.length) {
              this.navToImg(this.fileList[delIndex])
            }
            if (delIndex === this.fileList.length) {
              this.navToImg(this.fileList[this.fileList.length - 1])
            }
          }
        }
        this.saveFileListToValue()
      })
    },
    onProgress (event, file, fileList) {
      // console.log('onProgress::',event,file,fileList)
    },
    compressFile (file, quality, convertSize) {
      // eslint-disable-next-line no-new
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-new
        new ImageCompressor(file, {
          quality: quality || 0.6, // 压缩质量
          //  maxWidth: 500,
          //  maxHeight: 500,
          // 需要压缩的起始大小，默认1M, 1 * 1000 * 1000，只对PNG生效
          convertSize: convertSize || 1000000,
          checkOrientation: false, // 图片翻转，默认为false

          success: function (result) {
            // console.log('压缩之后图片尺寸大小: ', result.size)
            // console.log('mime 类型: ', result.type)
            // console.log('实际压缩率： ', ((file.size - result.size) / file.size * 100).toFixed(2) + '%')
            // console.log('需要压缩的起始大小: ', convertSize)
            resolve(result)
          },
          error (e) {
            console.log('压缩错误: ', e.message)
            reject(e)
          }
        })
      })
    },
    asyncImgChecked (file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.readAsDataURL(file) // 必须用file.raw
        reader.onload = () => { // 让页面中的img标签的src指向读取的路径
          let img = new Image()
          img.src = reader.result
          if (img.complete) { // 如果存在浏览器缓存中
            resolve({width: img.width, height: img.height})
          } else {
            img.onload = () => {
              resolve({width: img.width, height: img.height})
            }
          }
        }
      })
    },
    setFileName (fileName) {
      let uploadName = this.updateParams.fileName.replace(/\s+/g, '_')
      let num = this.uploadNum
      let extension = this.getFileExtension(fileName, 'subEnd')
      // 返回扩展名
      return `${uploadName}_${this.updateParams.code}_${num}${extension}`
    },
    getFileExtension (fileName, type) {
      // 使用 lastIndexOf 方法找到最后一个点的位置
      let lastDotIndex = fileName.lastIndexOf('.')
      // 如果没有找到点，返回空字符串或适当的默认值
      if (lastDotIndex === -1) return ''
      // 截取从点到字符串末尾的部分作为扩展名
      let extension = ''
      if (type === 'subEnd') {
        extension = fileName.substring(lastDotIndex)
      } else {
        extension = fileName.substring(0, lastDotIndex)
      }
      return extension
    },
    // 使用http-request方法的时候,:on-success,: on-error指令是不会触发的
    async uploadImage (event) {
      let that = this
      var apiObj = config.apiObj
      let file = event.file
      // console.log('上传文件::', file)

      // default:'.jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.GIF,.BMP,.PDF,.pdf,.docx,.xlsx'
      // console.log(Number(size))
      // console.log(Number(convertSize))
      // console.log(Number(quality))
      const isJPG =
        file.type === 'image/jpg' ||
        file.type === 'image/jpeg' ||
        file.type === 'image/png'
      if (isJPG) {
        file = await this.compressFile(
          event.file
        )
      }
      let pixel = ''
      var formData = new FormData()
      let uploadName = this.setFileName(file.name)
      console.log(this.ifSetUploadName)
      if (this.ifSetUploadName) {
        this.uploadNum++
        var fileNew = new File([file], uploadName)
        formData.append('file', fileNew)
        await this.asyncImgChecked(fileNew).then(data => {
          if (data) {
            pixel = data.width + '*' + data.height
          }
        })
      } else {
        formData.append('file', file, file.name)
        await this.asyncImgChecked(event.file).then(data => {
          if (data) {
            pixel = data.width + '*' + data.height
          }
        })
      }
      let params = {
        type: 'portfolio_gallery',
        uploadPath: 'userdir'
      }
      await apiObj.uploadFileUrl(formData, params).then((res) => {
        // param.onSuccess(res)
        if (res) {
          let params = {
            uid: res.data,
            name: this.ifSetUploadName ? this.getFileExtension(uploadName, '') : this.getFileExtension(file.name, ''),
            url: this.setUrlHearder(res.data),
            filePath: res.data,
            fileSize: file.size,
            fileName: this.ifSetUploadName ? uploadName : file.name,
            type: 'new',
            pixel: pixel
          }
          that.fileList.push(params)
          this.appendFileToValue(params)
          that.navToImg(params)
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
.projectFileUpload .delIconClass {
  font-size: 30px;
  color: white;
  float: right;
  position: relative;
  right: 30px;
  top: 1px;
  opacity: 1;
  cursor: pointer;
}

.upload-demo {
  display: flex;
  width: 100%;
}

.image-remove {
  font-size: 30px;
  width: 40px !important;
  height: 40px !important;
  text-align: start !important;
  transform: rotate(45deg);
  cursor: pointer;
  opacity: 0.8;
  top: -86px !important;
  right: -63px !important;
  display: block;
  position: relative !important;
  z-index: 9;
  color: white;
}


.image-remove-icon {
  font-size: 20px;
  font-weight: bold;
  width: 22px !important;
  height: 22px !important;
  text-align: center !important;
  top: 0px !important;
  right: 0px !important;
  display: block;
  position: absolute !important;
  z-index: 999;
  opacity: 0.8;
  background-color: #fff;
  border: 1px solid #d9d9d9;
}
</style>
